import { render } from "./WechatUserView.vue?vue&type=template&id=327c9fee&scoped=true"
import script from "./WechatUserView.vue?vue&type=script&lang=js"
export * from "./WechatUserView.vue?vue&type=script&lang=js"

import "./WechatUserView.vue?vue&type=style&index=0&id=327c9fee&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-327c9fee"]])

export default __exports__